export const firebaseConfig = {
  apiKey: "AIzaSyC19Vdiupi-15k20G8F5FWr_HceL7qPfKI",
  authDomain: "camunda-api.firebaseapp.com",
  projectId: "camunda-api",
  storageBucket: "camunda-api.appspot.com",
  messagingSenderId: "512401287610",
  appId: "1:512401287610:web:60612663e2d3cded1d1583",
  measurementId: "G-GR74BPEFE0",
};
